<template>
  <form @submit.prevent="validateCoupon" class="coupon-form">
    <div class="input-container">
      <label for="coupon-input" class="mb-2">{{ __('Insira seu cupom de desconto') }}</label>
      <input
        id="coupon-input"
        name="coupon-input"
        type="text"
        :disabled="disabled"
        v-model="code"
      >
      <span v-if="message.content" :class="`message-${message.type}`">
        {{ message.content }}
      </span>
    </div>

    <button
      id="coupon-button"
      type="submit"
      :disabled="loading || disabled"
    >
      {{ loading ? __('Carregando') + '...' : __('Validar cupom') }}
    </button>
  </form>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      coupon: null,
      code: null,
      message: {
        content: null,
        type: null,
      },
      loading: false,
    };
  },

  watch: {
    coupon (value) {
      this.$emit('coupon:changed', value);
    },
  },

  methods: {
    validateCoupon () {
      if (!this.code) {
        this.message.content = this.__('O código do cupom não pode ser vazio');
        this.message.type = 'error';

        this.coupon = null;

        return;
      }

      this.loading = true;

      this.$http.post(`coupon/${this.code}/validate`).then((response) => {
        const { message, coupon } = response.body;

        this.message.content = message;
        this.message.type = 'success';

        this.coupon = coupon;
      }).catch((response) => {
        const { message } = response.body;

        this.message.content = message ?? this.__('Erro ao validar cupom');
        this.message.type = 'error';

        this.coupon = null;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

.coupon-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .input-container {
    label {
      @include salesflow-text;
    }

    #coupon-input {
      width: 100%;;
      background: white;
      border: 1px solid $salesflow-outline-gray-medium;
      border-radius: 8px;
      padding: 0.75rem;

      @include salesflow-subtitle($color: $salesflow-font-dark);

      &:focus {
        box-shadow: 0px 0px 0px 4px #0D6EFD40 !important;
      }

      transition: box-shadow 0.25s;
    }

    span {
      @include salesflow-text;
      font-size: 0.875rem;
      font-family: 'Inter';

      &.message-success {
        color: $salesflow-secondary-hover;
      }

      &.message-error {
        color: $salesflow-info;
      }
    }
  }

  #coupon-button {
    padding: 0.75rem 1.125rem;
    background: transparent;
    border-radius: 14px;
    border: 1px solid $salesflow-primary;

    @include salesflow-subtitle($color: $salesflow-primary, $font-weight: 600);

    &:hover:not(:disabled) {
      cursor: pointer;
      background: $salesflow-primary-hover;
      color: white;
      border: 1px solid $salesflow-primary-hover;
    }
  }
}

</style>
